import { render, staticRenderFns } from "./CardOffered.vue?vue&type=template&id=50d70bb3&scoped=true&"
import script from "./CardOffered.vue?vue&type=script&lang=js&"
export * from "./CardOffered.vue?vue&type=script&lang=js&"
import style0 from "./CardOffered.vue?vue&type=style&index=0&id=50d70bb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d70bb3",
  null
  
)

export default component.exports